/**
 * Módulo: Carruseles de productos afiliados (Swiper)
 * =============================================================================
 * Carga Swiper solo si hay [data-tf-affiliate-carousel] en la página.
 */

/**
 * @param {ParentNode} root
 */
export async function initAffiliateCarousels(root = document) {
  const sections = root.querySelectorAll('[data-tf-affiliate-carousel]');
  if (!sections.length) {
    return;
  }

  const [{ default: Swiper }, { Navigation, Pagination, A11y, Autoplay }] = await Promise.all([
    import('swiper'),
    import('swiper/modules'),
  ]);

  sections.forEach((section) => {
    const swiperEl = section.querySelector('.tf-affiliate-carousel__swiper');
    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    const slidesDesktop = parseInt(section.dataset.slidesDesktop, 10) || 3;
    const slidesTablet = parseInt(section.dataset.slidesTablet, 10) || 2;
    const slidesMobile = parseInt(section.dataset.slidesMobile, 10) || 1;
    const autoplayEnabled = section.dataset.autoplay === '1';

    const swiper = new Swiper(swiperEl, {
      modules: [Navigation, Pagination, A11y, Autoplay],
      slidesPerView: slidesMobile,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        640: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: slidesDesktop,
          spaceBetween: 24,
        },
      },
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination'),
        clickable: true,
      },
      autoplay: autoplayEnabled
        ? {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        : false,
      a11y: {
        enabled: true,
      },
    });

    if (autoplayEnabled && swiper.autoplay) {
      swiper.autoplay.start();
    }
  });
}

const ELEMENTOR_READY_HOOKS = [
  'frontend/element_ready/titanfit_affiliate_carousel.default',
  'frontend/element_ready/shortcode.default',
  'frontend/element_ready/widget-shortcode.default',
];

/**
 * Elementor carga elementorFrontend después del bundle del tema; registrar en init.
 */
function registerElementorCarouselHooks() {
  const { elementorFrontend } = window;
  if (!elementorFrontend?.hooks) {
    return;
  }

  ELEMENTOR_READY_HOOKS.forEach((hook) => {
    elementorFrontend.hooks.addAction(hook, ($scope) => {
      const el = $scope?.[0] ?? $scope;
      if (el) {
        initAffiliateCarousels(el).catch(() => {});
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAffiliateCarousels().catch(() => {});
});

registerElementorCarouselHooks();

if (typeof window.jQuery !== 'undefined') {
  window.jQuery(window).on('elementor/frontend/init', () => {
    registerElementorCarouselHooks();
    initAffiliateCarousels(document).catch(() => {});
  });
}

if (typeof window.elementor !== 'undefined') {
  window.elementor.on('preview:loaded', () => {
    initAffiliateCarousels(document).catch(() => {});
  });
}
